(function () {
  'use strict';
  if (window.KCWhQualifySlider) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var all = [];

  function Slider(root) {
    this.root = root;
    this.track = root.querySelector('[data-kwqs-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-kwqs-slide]'));
    this.ctl = root.querySelector('[data-kwqs-ctl]');
    this.prev = root.querySelector('[data-kwqs-prev]');
    this.next = root.querySelector('[data-kwqs-next]');
    this.toggle = root.querySelector('[data-kwqs-toggle]');
    this.delay = parseInt(root.getAttribute('data-kwqs-auto'), 10) || 0;
    this.hover = false;
    this.keyFocus = false;
    this.touch = false;
    this.held = false;
    this.userPaused = false;
    this.visible = true;
    this.overflow = false;
    this.timer = 0;
    this.touchTimer = 0;
    this.drag = null;
    this.target = null;
    this.targetAt = 0;
    this.off = [];
    if (this.track && this.slides.length) this.init();
  }

  Slider.prototype.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts || false);
    this.off.push(function () { el.removeEventListener(type, fn, opts || false); });
  };

  Slider.prototype.init = function () {
    var self = this;
    this.root.classList.add('is-ready');
    this.on(this.prev, 'click', function () { self.go(-1); self.restart(); });
    this.on(this.next, 'click', function () { self.go(1); self.restart(); });
    if (this.toggle) {
      this.on(this.toggle, 'click', function () {
        self.userPaused = !self.userPaused;
        self.toggle.setAttribute('aria-pressed', String(self.userPaused));
        self.toggle.setAttribute('aria-label', self.toggle.getAttribute(self.userPaused ? 'data-label-play' : 'data-label-pause'));
        self.restart();
      });
    }
    this.on(this.root, 'pointerenter', function (e) { if (e.pointerType === 'mouse') { self.hover = true; self.stop(); } });
    this.on(this.root, 'pointerleave', function (e) { if (e.pointerType === 'mouse') { self.hover = false; self.restart(); } });
    this.on(this.root, 'focusin', function (e) {
      var t = e.target;
      var kb = false;
      try { kb = t.matches(':focus-visible'); } catch (err) { kb = true; }
      self.keyFocus = kb;
      if (kb) self.stop();
    });
    this.on(this.root, 'focusout', function (e) {
      if (!self.root.contains(e.relatedTarget)) { self.keyFocus = false; self.restart(); }
    });
    this.on(this.track, 'touchstart', function () { self.holdTouch(); }, { passive: true });
    this.on(this.track, 'touchend', function () { self.releaseTouch(); }, { passive: true });
    this.on(this.track, 'touchcancel', function () { self.releaseTouch(); }, { passive: true });
    this.on(this.track, 'wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { self.holdTouch(); self.releaseTouch(); } }, { passive: true });
    this.on(this.track, 'keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        self.go(e.key === 'ArrowRight' ? 1 : -1);
      }
    });
    this.on(this.track, 'pointerdown', function (e) { self.dragStart(e); });
    this.on(this.track, 'pointermove', function (e) { self.dragMove(e); });
    this.on(this.track, 'pointerup', function (e) { self.dragEnd(e); });
    this.on(this.track, 'pointercancel', function (e) { self.dragEnd(e); });
    this.on(this.track, 'dragstart', function (e) { e.preventDefault(); });
    this.on(this.track, 'click', function (e) {
      if (self.justDragged) { e.preventDefault(); e.stopPropagation(); self.justDragged = false; }
    }, true);
    this.on(document, 'visibilitychange', function () { self.restart(); });
    if (mq.addEventListener) this.on(mq, 'change', function () { self.restart(); });
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (es) {
        self.visible = es[es.length - 1].isIntersecting;
        self.restart();
      }, { threshold: 0.25 });
      this.io.observe(this.root);
    }
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(function () { self.measure(); });
      this.ro.observe(this.track);
    } else {
      this.on(window, 'resize', function () { self.measure(); });
    }
    this.measure();
  };

  Slider.prototype.measure = function () {
    this.overflow = this.track.scrollWidth - this.track.clientWidth > 2;
    if (this.ctl) this.ctl.hidden = !this.overflow;
    this.restart();
  };

  Slider.prototype.points = function () {
    var max = this.track.scrollWidth - this.track.clientWidth;
    var left = this.slides[0].getBoundingClientRect().left;
    var out = [];
    this.slides.forEach(function (s) {
      var p = Math.min(max, Math.max(0, s.getBoundingClientRect().left - left));
      if (!out.length || p - out[out.length - 1] > 1) out.push(p);
    });
    return out;
  };

  Slider.prototype.nearest = function (pts, x) {
    var best = 0;
    for (var i = 1; i < pts.length; i++) if (Math.abs(pts[i] - x) < Math.abs(pts[best] - x)) best = i;
    return best;
  };

  Slider.prototype.scrollToX = function (x) {
    var smooth = !mq.matches;
    this.target = x;
    this.targetAt = Date.now();
    if (this.track.scrollTo) this.track.scrollTo({ left: x, behavior: smooth ? 'smooth' : 'auto' });
    else this.track.scrollLeft = x;
  };

  Slider.prototype.go = function (dir) {
    if (!this.overflow) return;
    var t = this.track;
    var max = t.scrollWidth - t.clientWidth;
    var x = this.target != null && Date.now() - this.targetAt < 1200 ? this.target : t.scrollLeft;
    if (dir > 0 && x >= max - 2) return this.scrollToX(0);
    if (dir < 0 && x <= 2) return this.scrollToX(max);
    var pts = this.points();
    var i = Math.max(0, Math.min(pts.length - 1, this.nearest(pts, x) + dir));
    this.scrollToX(pts[i]);
  };

  Slider.prototype.canPlay = function () {
    return this.delay > 0 && this.overflow && !mq.matches && !this.userPaused && !this.hover && !this.keyFocus &&
      !this.touch && !this.held && !this.drag && this.visible && !document.hidden;
  };

  Slider.prototype.stop = function () {
    clearTimeout(this.timer);
    this.timer = 0;
  };

  Slider.prototype.restart = function () {
    var self = this;
    this.stop();
    if (!this.canPlay()) return;
    this.timer = setTimeout(function () {
      self.timer = 0;
      if (!self.canPlay()) return;
      self.go(1);
      self.restart();
    }, this.delay);
  };

  Slider.prototype.holdTouch = function () {
    clearTimeout(this.touchTimer);
    this.target = null;
    this.touch = true;
    this.stop();
  };

  Slider.prototype.releaseTouch = function () {
    var self = this;
    clearTimeout(this.touchTimer);
    this.touchTimer = setTimeout(function () { self.touch = false; self.restart(); }, Math.max(this.delay, 3000));
  };

  Slider.prototype.dragStart = function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0 || !this.overflow) return;
    this.target = null;
    this.drag = { id: e.pointerId, x: e.clientX, left: this.track.scrollLeft, moved: false };
    this.stop();
  };

  Slider.prototype.dragMove = function (e) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x;
    if (!d.moved && Math.abs(dx) < 5) return;
    if (!d.moved) {
      d.moved = true;
      this.track.classList.add('is-drag');
      try { this.track.setPointerCapture(d.id); } catch (err) {}
    }
    this.track.scrollLeft = d.left - dx;
  };

  Slider.prototype.dragEnd = function (e) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    this.drag = null;
    if (d.moved) {
      var t = this.track;
      var pts = this.points();
      var start = this.nearest(pts, d.left);
      var i = this.nearest(pts, t.scrollLeft);
      if (i === start) i += t.scrollLeft > d.left ? 1 : -1;
      var x = pts[Math.max(0, Math.min(pts.length - 1, i))];
      try { t.releasePointerCapture(d.id); } catch (err) {}
      t.classList.remove('is-drag');
      this.scrollToX(x);
      this.justDragged = true;
      var self = this;
      setTimeout(function () { self.justDragged = false; }, 50);
    }
    this.restart();
  };

  Slider.prototype.destroy = function () {
    this.stop();
    clearTimeout(this.touchTimer);
    this.off.forEach(function (fn) { fn(); });
    this.off = [];
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
  };

  Slider.prototype.show = function (slide) {
    this.held = true;
    this.stop();
    var max = this.track.scrollWidth - this.track.clientWidth;
    var p = slide.getBoundingClientRect().left - this.slides[0].getBoundingClientRect().left;
    this.scrollToX(Math.max(0, Math.min(max, p)));
  };

  function initIn(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kwqs]'), function (root) {
      if (root.__kwqs) return;
      root.__kwqs = new Slider(root);
      all.push(root.__kwqs);
    });
  }

  function destroyIn(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-kwqs]'), function (root) {
      if (root.__kwqs) { root.__kwqs.destroy(); all.splice(all.indexOf(root.__kwqs), 1); root.__kwqs = null; }
    });
  }

  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-kwqs-slide]');
    var root = slide && slide.closest('[data-kwqs]');
    if (root && root.__kwqs) root.__kwqs.show(slide);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-kwqs]');
    if (root && root.__kwqs) { root.__kwqs.held = false; root.__kwqs.restart(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initIn(document); });
  else initIn(document);
  window.KCWhQualifySlider = { init: initIn };
})();
